var _polygon, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-skip-back",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19 20 9 12 19 4 19 20"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    x2: 5,
    y1: 19,
    y2: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPrev);
export default __webpack_public_path__ + "static/media/ic_prev.d1c51df0b953fc5b1619eb2a3ec3342f.svg";
export { ForwardRef as ReactComponent };